import { GLOBAL_CONFIG } from '../constants/global.config'
import { DomainConfig } from '../types'

const config: DomainConfig = {
  ...GLOBAL_CONFIG,
  APP_KEY: 'BWC',
  CLIENT_ID: '14',
  COUNTRY: 'bwc'
}

export default config
